import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import qs from 'qs';

import Layout from '../components/layout';
import SEO from '../components/seo';
import { LocationProp } from '../props/LocationProps';

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100vh;
  border: 0;
`;

const LiveDemoPage = ({ location }) => {
  const site = (location.href || '')
    .replace(/.+\/livedemo\//, '');
  if (!site) {
    return null;
  }
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  // redirect to http
  if (typeof window !== 'undefined') {
    const { origin } = window.location;
    if (/^https/.test(origin) && query.http === 'true') {
      const domain = window.location.origin.replace(/http(s)*:\/\//, '');
      window.location.href = `http://${domain}/livedemo/${site}`;
      return (
        <SEO
          title={site}
          description={`Web Design Theme example on ${site}`}
        />
      );
    }
  }
  return (
    <Layout>
      <SEO
        title={site}
        description={`Web Design Theme example on ${site}`}
      />
      <StyledIframe src={`//${site}`} />
    </Layout>
  );
};

LiveDemoPage.propTypes = {
  location: PropTypes.shape(LocationProp).isRequired,
};

export default LiveDemoPage;
